import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MOS, MosStateType } from './types';

const initialState: MosStateType = {
  connected: false,
  autoFetch: true,
  statusLoading: false,
};

export const mosSlice = createSlice({
  name: MOS,
  initialState,
  reducers: {
    requestMosResyncPlaylist: () => {},

    requestGetMosStatus: (state) => {
      state.statusLoading = true;
    },

    receiveMosStatus: (
      state,
      action: PayloadAction<{ connected: boolean; autoFetch: boolean }>,
    ) => {
      state.connected = action.payload.connected;
      state.autoFetch = action.payload.autoFetch;
      state.statusLoading = false;
    },

    requestToggleMosAutoFetch: (state) => {
      state.statusLoading = true;
    },
  },
});

const actions = mosSlice.actions;
const mosReducer = mosSlice.reducer;

export { actions, mosReducer };
